import axios from 'axios';
import React, { useEffect, useState } from 'react';

const ViewOrders = () => {
  const [orders, setOrders] = useState([]);
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [address, setAddress] = useState('');
  const [variants, setVariants] = useState([]);
  const [_id, setId] = useState('');

useEffect(() => {
  axios.get('https://ezer-eventapp.onrender.com/orders')
    .then(res => {
      const sortedOrders = res.data.sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
      setOrders(sortedOrders);
    })
    .catch(err => console.log(err));
}, []);

  const acceptOrder = (orderObj) => {
    axios.post("https://ezer-eventapp.onrender.com/accepted", orderObj)
      .then(() => axios.delete(`https://ezer-eventapp.onrender.com/orders/${orderObj._id}`))
      .then(() => {
        alert("Order accepted successfully");
        setOrders(orders.filter(o => o._id !== orderObj._id));
      })
      .catch(err => console.log(err));
  };

  const getOneRecord = (orderId) => {
    axios.get(`https://ezer-eventapp.onrender.com/orders/${orderId}`)
      .then(res => {
        const data = res.data;
        setName(data.name || '');
        setMobile(data.mobile || '');
        setAddress(data.address || '');
        setVariants(data.variants || []);
        setId(data._id || '');
      })
      .catch(err => console.log(err));
  };

  const updateEnq = (e) => {
    e.preventDefault();
    axios.put(`https://ezer-eventapp.onrender.com/orders/${_id}`, { _id, name, mobile, address, variants })
      .then(() => {
        alert("Order updated successfully");
        setOrders(orders.map(o => o._id === _id ? { ...o, name, mobile, address, variants } : o));
      })
      .catch(err => console.log(err));
  };

  return (
    <div className='container mt-5'>
      <h1 className='text-center mb-5'>View Orders</h1>

      {orders.length === 0 ? (
        <p className="text-center text-bg-success p-3">No orders yet</p>
      ) : (
        <div className='table-responsive' style={{ maxHeight: "500px" }}>
          <table className="table table-bordered table-hover">
            <thead className="table-dark text-center sticky-top">
              <tr>
                <th>S.No</th>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Mobile</th>
                <th>Vendor</th>
                <th>Items</th>
                <th>Total (₹)</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr key={order._id}>
                  <td className="text-center">{index + 1}</td>
                  <td>{order.orderId || ''}</td>
                  <td>{order.name || ''}</td>
                  <td>{order.mobile || ''}</td>
                  <td>{order.address || ''}</td>
                  <td>
                    <ul className="order-items mb-0">
                      {order.variants?.length > 0 ? (
                        order.variants.map(item => (
                          <li key={item._id || Math.random()}>
                            {item.name || 'Item'} {item.variant?.weight || ''} (
                            {item.qty || 0} × ₹{item.variant?.price || 0}) ={" "}
                            <strong>₹{item.subtotal || 0}</strong>
                          </li>
                        ))
                      ) : (
                        <li>No items</li>
                      )}
                    </ul>
                  </td>
                  <td><strong>₹{order.total || 0}</strong></td>
                  <td>{order.date || ''}</td>
                  <td>
                    {/* <button
                      onClick={() => getOneRecord(order._id)}
                      data-bs-toggle='modal'
                      data-bs-target='#update'
                      className='btn btn-primary me-2'
                    >
                      Edit
                    </button> */}
                    <button
                      onClick={() => acceptOrder(order)}
                      className='btn btn-success'
                    >
                      Accept
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Update Modal */}
      <div className='modal' id='update'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Edit Order</h5>
              <button type='button' className='btn-close' data-bs-dismiss='modal'></button>
            </div>
            <div className='modal-body'>
              <form onSubmit={updateEnq}>
                <input
                  onChange={e => setName(e.target.value)}
                  name="name"
                  className='form-control mb-3'
                  placeholder='Enter name'
                  value={name}
                />
                <input
                  onChange={e => setMobile(e.target.value)}
                  name="mobile"
                  className='form-control mb-3'
                  placeholder='Enter mobile number'
                  value={mobile}
                />
                <input
                  onChange={e => setAddress(e.target.value)}
                  type="text"
                  className='form-control mb-3'
                  placeholder='Enter address'
                  value={address}
                />
                <input
                  type="submit"
                  className='form-control btn btn-success'
                  value="Update Order"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOrders;
